import React, { useContext, useState } from 'react'

const LoadingContext = React.createContext()
export const useLoading = () => useContext(LoadingContext)

export const LoadingProvidor = ({ children }) => {
  const [loading, setLoading] = useState(null)

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}
